/*
 * 文件EN: riskScreen.js,
 * 文件CN: 风控云台,
 * 创建时间: Monday, 1st June 2020 3:27:43 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http';

/**
 * @desc 交易数据统计
 * @method GET
 * @param { 参数说明 详细见swagger  } 
 */
export const fetchEcharts = params => {
	return request.get('/riskScreen/transactionData', params)
}

/**
 * @desc 风控巡查列表---交易要素和交易效验
 * @method GET
 * @param { id: 交易流水号id  int} 
 */
export const selectTradingElements = params => {
	return request.get('/riskScreen/selectTradingElements', params)
}

/**
 * @desc 风控巡查列表---查询历史交易经纬度
 * @method GET
 * @param { hostTime: 交易流水号id, merNo, supId  } 
 */
export const selectCoordinate = params => {
	return request.get('/riskScreen/selectCoordinate', params)
}

/**
 * @desc 风控巡查列表---添加预设交易过滤
 * @method GET
 * @param { 见swagger  } 
 */
export const saveAdvanceTradeFilter = params => {
	return request.get('/riskScreen/saveAdvanceTradeFilter', params)
}

/**
 * @desc 风控巡查列表---查询预设交易过滤
 * @method GET
 * @param { 见swagger  } 
 */
export const getAdvanceTradeFilter = params => {
	return request.get('/riskScreen/getAdvanceTradeFilter', params)
}

/**
 * @desc 风控巡查列表---历史被管控对象
 * @method GET
 * @param { keyWord: 关键字: 商户名称、商户编号、供应商名称、供应商编号  } 
 */
export const historyControlled = params => {
	return request.get('/riskScreen/historyControlled', params)
}

/**
 * @desc 风控巡查列表---添加介入风控记录
 * @method POST
 * @param { 见swagger 巨多请求参数  } 
 */
export const interventionRisk = params => {
	return request.post('/riskScreen/interventionRisk', params)
}
